import React, {useContext} from 'react';
import {FormattedMessage} from "react-intl";

import SidebarItem from "../../../SidebarItem";

import {ReactComponent as ShopIcon} from "assets/img/shop.svg";

import {Authorizations, hasAuthorization} from "utils/authorizations";
import {OMSRoutes} from "utils/OMSRoutes";

import {SidebarContext} from "../../../../../../SidebarContext";

function RetailersItem(props) {
    const {currentPath, currentMemberAuthorizations} = useContext(SidebarContext);

    if (hasAuthorization(currentMemberAuthorizations, Authorizations.PICKING_RETAILER)) {
        return null;
    }

    return (
        <SidebarItem
            isTopLevel
            icon={<ShopIcon />}
            to={OMSRoutes.RETAILERS_LIST}
            selected={currentPath.startsWith(OMSRoutes.RETAILERS)}
        >
            <FormattedMessage id='sidebar.oms.item.retailers' />
        </SidebarItem>
    );
}

export default RetailersItem;
